// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ba39464","952":"8d725d85"}[chunkId] + ".chunk.js";
};